import { observer } from "mobx-react-lite";

import { useCountries } from "../../catalogs/countries";
import { Combobox } from "../../components/ui-kit/fields/combobox";

export const CountrySelect = observer(function CountrySelect(props: {
  model?: Record<string, any>;
  attr?: string;
  regionAttr?: string;
  value?: string;
  onChange?: (newValue: string) => void;
  required?: boolean;
}) {
  const countries = useCountries();
  return (
    <Combobox<string>
      options={countries.countriesEnum.map((c) => ({
        label: c,
        value: c,
      }))}
      model={props.model}
      attr={props.attr}
      value={props.value}
      onChange={(newValue) => {
        if (props.regionAttr && props.model) {
          props.model[props.regionAttr] = 0; // Set the default catch-all region
        }
        props.onChange?.(newValue);
      }}
      required={props.required}
    />
  );
});
